export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export default function hideMessage() {
    return { type: HIDE_MESSAGE };
}
